'use strict';

function formatErrorMessage(message, errorCode) {
    return errorCode
        ? `${message}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${errorCode}`
        : message;
}

exports.formatErrorMessage = formatErrorMessage;
//# sourceMappingURL=format-error-message.cjs.map
